export default __webpack_public_path__ + "static/media/desktop.e031304f.png";